import { Navigate, Outlet } from 'react-router-dom';
import Cookies from "js-cookie";

const PublicRoute = () => {
    let token = Cookies.get("token")
    return !token ? <Outlet /> : <Navigate to={'/'} />
}
export default PublicRoute